import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getType } from 'deox';
import {
  addUserSong,
  cancelUploadUserSong,
  getUserSongsCancelUploadId,
  setLoading,
  setUserSongLoadingCancelId,
  uploadUserTrack
} from 'modules/userSongs';
import { addContent } from 'utils/apiWrapper';
import { setAudio } from 'modules/audio';
import { addAlert } from 'modules/alert';
import getMediaDuration from 'utils/getMediaDuration';
import { getFile } from 'utils/fileCache';
import analytics from 'utils/analytics';
import { ACCEPTED_AUDIO } from 'constants/filetypes';
import { audioMessages } from 'constants/errorMessages';
import { saveRevision } from 'modules/revisions';
import { ToolName } from 'types/AppState';
import { CANCEL_MESSAGE, cancelById, createToken, removeToken } from 'utils/cancelableRequests';
import { getPlayer } from 'utils/PlayerContext';
import { getUserKey } from 'modules/user';

export function* uploadUserTrackSaga({ payload: { file } }: ReturnType<typeof uploadUserTrack>) {
  if (!ACCEPTED_AUDIO.includes(file.type)) {
    yield put(addAlert(audioMessages.title, audioMessages.uploadingMp3));
    return;
  }
  const { token, cancelId } = createToken();
  getPlayer().pause();
  yield put(setAudio(null));
  yield put(setLoading(true));
  yield put(setUserSongLoadingCancelId(cancelId));
  const name = file.name || 'Unknown';
  try {
    const userKey: string | null = yield select(getUserKey);
    const src: string = yield call(addContent, file, userKey, null, token);
    const cachedFile: string = yield call(getFile, src, { cancelToken: token });
    const duration: number = yield call(getMediaDuration, cachedFile, 'audio');
    yield put(
      addUserSong({ url: src, songName: name, isPaid: false, duration, id: `${src}${name}` })
    );
    yield put(setAudio({ url: src, songName: name, isPaid: false, duration }));
    yield put(setLoading(false));
    yield call([analytics, analytics.musicAction], {
      is_premium: false,
      result_source: 'local',
      music_duration: Math.ceil(duration / 1000)
    });
    yield call([analytics, analytics.uploadDone], { item: 'music', result: 'success' });
    yield put(saveRevision(ToolName.Music));
  } catch (e) {
    yield put(setLoading(false));
    if (token.reason.message !== CANCEL_MESSAGE) {
      yield put(addAlert(audioMessages.title, audioMessages.uploadingError));
      yield call([analytics, analytics.uploadDone], { item: 'music', result: 'fail' });
    }
  }
  removeToken(cancelId);
}

export function* cancelUploadUserSongSaga() {
  const cancelId: string = yield select(getUserSongsCancelUploadId);

  if (cancelId) {
    cancelById(cancelId);
    removeToken(cancelId);
    yield setLoading(false);
    yield put(setUserSongLoadingCancelId(undefined));
  }
}

export default function* audioSaga() {
  yield takeEvery(getType(uploadUserTrack), uploadUserTrackSaga);
  yield takeEvery(getType(cancelUploadUserSong), cancelUploadUserSongSaga);
}
